module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/31_ed2208a44832c21e52288991a0f6c3c8.jpg";